import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';

import {
  cancelEditWorkExperience,
  deleteWorkExperience,
  scrolledToExperience,
} from 'shared/portfolio/actions/work-experiences';

import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import WorkExperienceForm from 'shared/portfolio/components/work-experiences/work-experience-form';
import WorkExperienceFormWrapper, {WorkExperience} from './work-experience-form-wrapper';
import FormCard from '../form-card';

interface Props {
  workExperience: WorkExperience;
}

const WorkExperienceFormCard = ({workExperience}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (workExperience.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToExperience(workExperience._id));
      }, 550);
    }
  }, [dispatch, workExperience._id, workExperience.scrollTo]);

  return (
    <FormCard ref={ref} id={workExperience._id}>
      <h4 className="portfolio-sections add-edit-header">
        {workExperience.new ? 'Add Work Experience' : 'Edit Work Experience'}
      </h4>

      <WorkExperienceFormWrapper initialValues={workExperience}>
        <WorkExperienceForm />

        <PortfolioFormFooter
          _id={workExperience._id}
          onCancel={() => dispatch(cancelEditWorkExperience(workExperience))}
          onDelete={() => dispatch(deleteWorkExperience(workExperience._id))}
          formName="portfolio work-experiences work-experience-form"
        />
      </WorkExperienceFormWrapper>
    </FormCard>
  );
};

export default WorkExperienceFormCard;
